import {
  GET_DASHBOARD,
  GET_DASHBOARD_FAILURE,
  GET_DASHBOARD_SUCCESS,
} from "../../Actions/types";

const initialState = {
  loader: false,
  error: false,
  data: null,
};
function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case GET_DASHBOARD:
      return { ...state, data: action?.payload, loader: true };
    case GET_DASHBOARD_SUCCESS:
      return { ...state, data: action?.payload, error: false, loader: false };
    case GET_DASHBOARD_FAILURE:
      return { ...state, error: true, loader: false };

    default:
      return state;
  }
}

export default dashboardReducer;
